import store from '@/store'
import axios from 'axios'
import Vue from 'vue'

const state = {
  status: '',
  token: '',
  user: {},
  username: '',
  adminMode: false,
  baseUrl: 'https://flux.aed.pro'
}

const mutations = {
  authRequest (state) {
    state.status = 'loading'
  },
  authSuccess (state, data) {
    state.status = 'success'
    state.token = data.token
    state.username = data.username
    state.baseUrl = data.url
  },
  updateUser (state, user) {
    state.user = user
  },
  authError (state) {
    state.status = 'error'
    state.token = ''
  },
  logout (state) {
    state.status = ''
    state.token = ''
  },
  updateIsAdmin (state, adminMode) {
    state.adminMode = adminMode
  }
}

const actions = {
  login ({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      let sha1 = require('sha1')
      let data = `grant_type=password&username=${credentials.username}&password=${sha1(credentials.password)}`
      commit('authRequest')
      axios({ url: `${credentials.url}/token`, data: data, method: 'POST' })
        .then(response => {
          const token = response.data.access_token
          const userId = response.data.user_id
          Vue.prototype.$api.defaults.headers['Authorization'] = `Bearer ${token}`
          Vue.prototype.$api.defaults.baseURL = credentials.url + '/api/'
          store.dispatch('users/loadById', { id: userId }).then(() => {
            commit('updateUser', store.getters['users/byId']({ id: userId }))
            commit('authSuccess', { token: token, url: credentials.url, username: credentials.username })
            resolve(response)
          })
        })
        .catch(error => {
          commit('authError')
          reject(error)
        })
    })
  },
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('logout')
      delete axios.defaults.headers.common['Authorization']
      resolve()
    })
  },
  updateUser ({ dispatch, commit, getters }, user) {
    dispatch('roles/loadById', { id: user.relationships.role.data.id }).then(() => {
      user.role = getters['roles/byId']({ id: user.relationships.role.data.id })
      commit('updateUser', user)
    })
  }
}

const getters = {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  adminMode: state => state.adminMode
}

export default {
  state,
  mutations,
  getters,
  actions
}
